module.exports = __webpack_public_path__ + "img/circle_edit_solid.1d81835e.svg";